/**
 * Example auth api connector that lets your user log in using a defined payload
 * and returns a promise
 */

import api from '@/config/api'
import vuex from '@/store'

export default {
  getTopPitchers(days) {
    let station = vuex.getters.currentStation.station
    return api.get(`/v2/newsdesk/dashboard/pitchers/${station}/${days}`)
  },
  getContentCounts(type, days) {
    let station = vuex.getters.currentStation.station
    days = days ?? 30
    type = type ?? 'storyType'
    return api.get(`/v2/newsdesk/dashboard/${type}/${station}/${days}`)
  },
  getAllStationCounts(type, station, days) {
    station = station ?? 'all'
    days = days ?? 30
    type = type ?? 'storyType'
    return api.get(`/v2/newsdesk/dashboard/${type}/${station}/${days}`)
  },
  getShowBreakdown() {
    let station = vuex.getters.currentStation.station
    return api.get(`/v2/newsdesk/dashboard/today/breakdown/${station}`)
  },
  getSafetyPinLocations() {
    let station = vuex.getters.currentStation.station
    return api.get(`/v2/newsdesk/safetypin/geo/${station}`)
  }
}
